import { reactBinding, createForm, fields } from "rd-redux-forms";

export interface SignupFormFields {
    name: string;
    email: string;
    category: string;
    industry: string;
}

export const signupForm = createForm<SignupFormFields>("SIGNUP FORM", {
    name: fields.string(true),
    email: fields.string(true),
    category: fields.string(false),
    industry: fields.string(false)
});

export const signupFormBindings = reactBinding()
    .default()
    .withForm(signupForm);

export interface SignupState {
    signupForm: typeof signupForm.types.state;
    isOpenSignup: boolean;
    signupSendingFlag: boolean;
}

export const defaultSignupState: SignupState = {
    signupForm: signupForm.state.empty(),
    isOpenSignup: false,
    signupSendingFlag: false
};
